import ProfilePicSource from '../../img/portfolio/about/profile-pic-jason-toups-masked.png';

export const ProfilePic = {
  source: ProfilePicSource,
  alt: 'Jason Toups Profile Pic',
  className: 'profile-pic',
};

export default ProfilePic;
